import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import "./App.css";

import Landing from "./pages/Landing";
import Pricing from "./pages/Pricing";
import CheckoutSuccess from "./pages/CheckoutSuccess";
import PortalLogin from "./pages/PortalLogin";
import PortalDashboard from "./pages/PortalDashboard";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import ConceptPreview from "./pages/ConceptPreview";
import SimplicitySells from "./pages/SimplicitySells";
import FutureOfAISearch from "./pages/FutureOfAISearch";
import ScrollToTop from "./components/ScrollToTop";
import { getUser } from "./lib/api";

const RequireRole = ({ role, children }) => {
  const u = getUser();
  if (!u || u.role !== role) return <Navigate to={role === "admin" ? "/admin/login" : "/portal/login"} replace />;
  return children;
};

export default function App() {
  return (
    <div className="App">
      <Toaster position="top-right" />
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/framework" element={<SimplicitySells />} />
          <Route path="/ai-search" element={<FutureOfAISearch />} />
          <Route path="/concepts/:slug" element={<ConceptPreview />} />
          <Route path="/checkout/success" element={<CheckoutSuccess />} />
          <Route path="/portal/login" element={<PortalLogin />} />
          <Route path="/portal" element={<RequireRole role="client"><PortalDashboard /></RequireRole>} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<RequireRole role="admin"><AdminDashboard /></RequireRole>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}
